import { Banner } from 'components/Banner';
import styled from 'styled-components';

export const Dac7Banner = styled(Banner)`
  height: 140px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.1), 1px 1.5px 6px 0px rgba(0, 0, 0, 0.15);
`;
